// Static content for Orina Enterprise

export const COMPANY = {
  name: "Orina Enterprise",
  tagline: "Leading e-commerce & quick commerce growth partner in India — marketplace onboarding, account management, listings, ads, A+ graphics, videos, CRM & manpower under one roof.",
  positioning: "Top E-commerce Service Provider for Indian Brands",
  // Calls go to the phone number; WhatsApp chats and lead forwarding go to the
  // WhatsApp number (the one on the Google Business Profile).
  whatsapp: "+919594983478",
  whatsappDisplay: "+91 95949 83478",
  whatsappE164: "+91-95949-83478",
  phoneTel: "+918178965407",
  phoneE164: "+91-81789-65407",
  whatsappMessage: "Hi, I want to start selling online",
  email: "letstalk@orinaenterprise.com",
  phone: "+91 81789 65407",
  address: "5th floor, 307, Chincholi Bunder Rd, Malad, Rajan Pada, Mindspace, Malad West, Mumbai, Maharashtra 400064, India",
  rating: 4.8,
  reviewsCount: 187,
};

// Google Business listing / reviews
export const GOOGLE_LISTING = {
  name: "Orina Enterprise on Google",
  category: "E-commerce service, Mumbai",
  shareUrl: "https://share.google/foxTUG83xB09IlHwT",
  mapsUrl: "https://www.google.com/maps?cid=6582171098402440499",
  cid: "6582171098402440499",
  // Reliable URL that opens the Google Business knowledge panel with a
  // "Write a review" button. Share URLs are the safest option because they
  // don't require the exact Place ID (which is not publicly exposed).
  writeReviewUrl: "https://share.google/foxTUG83xB09IlHwT",
  fallbackReviewUrl: "https://www.google.com/maps?cid=6582171098402440499&action=review",
};

export const SERVICES = [
  {
    id: "account-management",
    icon: "Activity",
    title: "E-commerce Account Management",
    short: "End-to-end management of your marketplace accounts so you can focus on building products.",
    full: "We operate your seller accounts daily — orders, returns, inventory, pricing, performance, and customer escalations. Our managers act as your in-house e-commerce team without the overhead.",
    bullets: ["Daily order & inventory ops", "Return rate reduction", "Pricing & promotions", "Performance reviews"],
  },
  {
    id: "onboarding",
    icon: "Rocket",
    title: "Seller Onboarding & Account Launch",
    short: "Go live on Amazon, Flipkart, Meesho, JioMart, Nykaa & more in days, not months.",
    full: "From GST and brand documentation to category approval and first-listing launch — we handle the full registration and go-live process across every major Indian marketplace.",
    bullets: ["Brand & GST registration", "Category approvals", "Catalog upload", "Go-live within 7 days"],
  },
  {
    id: "listing-optimization",
    icon: "Sparkles",
    title: "Listing Optimization",
    short: "Rank higher, convert more — with keyword-rich titles, A+ content, and pro imagery.",
    full: "Listings designed to win the buy-box. We rewrite titles, bullet points, descriptions, and produce A+ / EBC content that tells your brand story and converts browsers into buyers.",
    bullets: ["Keyword research & SEO", "A+ / EBC content", "Pro photography briefs", "Conversion-focused copy"],
  },
  {
    id: "ads-growth",
    icon: "TrendingUp",
    title: "Ads & Growth Strategy",
    short: "PPC, Sponsored Brands, Display & Coupons — managed for ROAS, not vanity metrics.",
    full: "We architect and run profitable ad campaigns across Amazon Ads, Flipkart PLA, Meesho Ads & more. Bid management, search-term harvesting, and weekly ROAS reporting included.",
    bullets: ["Sponsored Products & Brands", "ROAS-driven bid strategy", "Coupon & deal calendars", "Weekly growth reports"],
  },
  {
    id: "compliance",
    icon: "ShieldCheck",
    title: "Account Health & Compliance",
    short: "Stay live, avoid suspensions — proactive policy & performance monitoring.",
    full: "Account suspensions can cost months of revenue. We monitor policy violations, IP complaints, performance KPIs, and resolve issues before they escalate — including reinstatement appeals.",
    bullets: ["Policy violation tracking", "Suspension reinstatement", "IP & brand protection", "Performance KPI alerts"],
  },
  {
    id: "web-app",
    icon: "Code2",
    title: "Website & App Development",
    short: "D2C storefronts, mobile apps, and headless commerce — built for speed and scale.",
    full: "Modern, performant Shopify, WooCommerce, and custom React/Next.js storefronts. Mobile apps for iOS & Android. We integrate logistics, payments, and your marketplace catalogs.",
    bullets: ["Shopify / Custom storefronts", "iOS & Android apps", "Payment & logistics", "Marketplace integrations"],
  },
];

export const MARKETPLACES = [
  { name: "Amazon", color: "#FF9900", desc: "India's #1 marketplace by GMV" },
  { name: "Flipkart", color: "#2874F0", desc: "India's flagship e-commerce platform" },
  { name: "Meesho", color: "#9F2089", desc: "Tier 2/3 social commerce leader" },
  { name: "JioMart", color: "#008ECC", desc: "Reliance's omni-channel marketplace" },
  { name: "Ajio", color: "#2D2D2D", desc: "Premium fashion & lifestyle" },
];

export const PREMIUM_MARKETPLACES = [
  { name: "Nykaa", color: "#FC2779", desc: "Beauty & wellness category leader" },
  { name: "Myntra", color: "#FF3F6C", desc: "India's #1 fashion destination" },
  { name: "Ajio Luxe", color: "#8B0000", desc: "Curated premium & luxury" },
  { name: "Tata Cliq", color: "#D8232A", desc: "Authentic premium brands" },
];

export const QUICK_COMMERCE = [
  { name: "Blinkit", color: "#FFD200", desc: "10-min grocery & essentials" },
  { name: "Zepto", color: "#7B2CBF", desc: "Ultra-fast 10-min delivery" },
  { name: "Instamart", color: "#FF5200", desc: "Swiggy's quick-commerce arm" },
  { name: "Swiggy", color: "#FC8019", desc: "Food + Instamart marketplace" },
];

export const TESTIMONIALS = [
  {
    name: "Rahul Mehta",
    role: "Founder",
    company: "Wellnest Naturals",
    quote: "Orina took us from zero to ₹1.2Cr GMV on Amazon in 9 months. Their listing & ad team is sharper than any agency we've worked with.",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    role: "Director",
    company: "Avani Apparel",
    quote: "We were stuck on Myntra approval for 6 months. Orina got us live in 3 weeks and we crossed ₹40L in our first quarter.",
    rating: 5,
  },
  {
    name: "Karan Shah",
    role: "CEO",
    company: "BrewBox Coffee",
    quote: "Quick commerce was a black box for us. Their Blinkit & Zepto onboarding playbook is the real deal — 4x sell-through in week one.",
    rating: 5,
  },
  {
    name: "Anjali Verma",
    role: "Co-founder",
    company: "Nuvi Skincare",
    quote: "Account suspended on Amazon for IP complaint — Orina reinstated us in 6 days. Saved our entire Q4. Lifetime customer.",
    rating: 5,
  },
  {
    name: "Vikram Reddy",
    role: "Brand Head",
    company: "Forge Footwear",
    quote: "Their reporting is what convinced us. Weekly P&L per channel, ROAS by SKU, returns root-cause. Finally, decisions on data.",
    rating: 5,
  },
  {
    name: "Neha Iyer",
    role: "Founder",
    company: "Lumière Candles",
    quote: "Got us approved on Nykaa AND Myntra in the same quarter. Their premium-marketplace playbook is the real deal — saved us 6 months of back-and-forth.",
    rating: 5,
  },
  {
    name: "Arjun Malhotra",
    role: "Operations Head",
    company: "Crispy Bites Snacks",
    quote: "Blinkit was a black box. Orina onboarded us in 18 days and our Mumbai sell-through hit 92% in week one. Now scaling to Bangalore and Delhi.",
    rating: 5,
  },
  {
    name: "Sneha Kapoor",
    role: "Co-founder",
    company: "BlissBath",
    quote: "We were running ads on Amazon at 35% ACoS. Orina's team brought it down to 14% in 8 weeks without cutting volume. Honest, sharp, and accountable.",
    rating: 5,
  },
  {
    name: "Mohammed Asif",
    role: "Director",
    company: "Asif Textiles",
    quote: "Meesho was killing us with returns. Their packaging + QC playbook dropped returns from 41% to 22% in two months. Genuine partners.",
    rating: 5,
  },
  {
    name: "Divya Rao",
    role: "Marketing Lead",
    company: "GreenStem Plants",
    quote: "JioMart was on our list for a year. Orina got us listed in 14 days and into the festive deals page. Q4 revenue tripled. No drama.",
    rating: 5,
  },
  {
    name: "Rohit Bansal",
    role: "Founder",
    company: "Forge Activewear",
    quote: "Quick commerce was the missing piece for us. Orina onboarded us on Blinkit + Zepto + Instamart in 25 days. November alone did ₹38L across the three platforms.",
    rating: 5,
  },
];

export const WHY_CHOOSE_US = [
  { title: "End-to-end execution", desc: "From GST to GMV — one team, every step." },
  { title: "Marketplace expertise", desc: "10+ platforms, 200+ brands launched." },
  { title: "Fast onboarding", desc: "Live in 7 days on most marketplaces." },
  { title: "Growth-driven approach", desc: "ROAS, not vanity dashboards." },
  { title: "Dedicated managers", desc: "One Slack channel. One owner. No bots." },
  { title: "Transparent reporting", desc: "Weekly P&L per channel, every Monday." },
];

export const FAQS = [
  { q: "Which marketplaces do you onboard sellers to?", a: "Amazon, Flipkart, Meesho, JioMart, Ajio, Nykaa, Myntra, Tata Cliq, Blinkit, Zepto and Instamart." },
  { q: "How long does seller onboarding take?", a: "Most marketplaces go live within 7 days. Premium marketplaces (Nykaa, Myntra) typically take 3–6 weeks due to brand approval." },
  { q: "Do you handle account suspensions?", a: "Yes. We have a 95%+ reinstatement success rate across Amazon, Flipkart and Meesho." },
  { q: "What is your pricing model?", a: "We offer fixed-fee onboarding packages and monthly retainers for account management. Free audit available." },
  { q: "Do you work with new brands?", a: "Absolutely. Most of our clients start as new D2C brands and scale to ₹1Cr+ on marketplaces in their first year." },
  { q: "Can I see weekly reports?", a: "Yes — every Monday you get a P&L per channel, ROAS by SKU, returns analysis, and growth roadmap." },
];
